import type { ComponentProps } from 'react';
import { cx } from 'src/view/shared/styles/cx';
import styles from './HeaderWrapper.module.css';

const HeaderWrapper = ({ className, ...rest }: ComponentProps<'div'>) => (
  <div className={cx(styles.headerWrapper, className)} {...rest} />
);

export default HeaderWrapper;
